import { render, staticRenderFns } from "./CheckBoxGroupView.vue?vue&type=template&id=55e0fd12&scoped=true"
import script from "./CheckBoxGroupView.vue?vue&type=script&lang=js"
export * from "./CheckBoxGroupView.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxGroupView.vue?vue&type=style&index=0&id=55e0fd12&prod&lang=scss"
import style1 from "./CheckBoxGroupView.vue?vue&type=style&index=1&id=55e0fd12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e0fd12",
  null
  
)

export default component.exports